import { gridManager } from './blocks-grid';
import { timelineManager } from './timeline';
class ClusterManager {
    clusterStepSelector = '.js-ClusterStep';
    clusterStepNextSelector = '.js-ClusterStep-Next';
    clusterStepPrevSelector = '.js-ClusterStep-Prev';
    clusterPageSelector = '.js-ClusterPage';
    clusterProgressSelector = '.js-Cluster__Progress';
    buttonActiveClass = 'Btn-White';
    buttonInactiveClass = 'Btn-Inactive';
    buttonVisitedClass = 'Btn-Accent';
    currentStep = 0;
    lastStepIndex = 0;
    init() {
        this.lastStepIndex = $(this.clusterStepSelector).length - 1;
        $(this.clusterStepNextSelector).on('click', this.handleNextStep.bind(this));
        $(this.clusterStepPrevSelector).on('click', this.handlePrevStep.bind(this));
        this.formInit();
    }
    formInit() {
        const forms = $('.Cluster__Page .js-Form');
        if (forms.length === 0)
            return;
        forms.each((_, element) => {
            const form = $(element);
            const contentSelector = '.Container-Content';
            const container = form.parent(contentSelector);
            form.data('onSubmitted', (result) => {
                const content = $(result).find(contentSelector).html();
                $(container).css({ display: 'none' });
                $(container).html(content);
                $(container).fadeIn(500);
            });
        });
    }
    handlePrevStep(event) {
        event.preventDefault();
        this.currentStep--;
        this.handleStep();
    }
    handleNextStep(event) {
        event.preventDefault();
        this.currentStep++;
        this.handleStep();
    }
    handleStep() {
        this.renderContentPage(this.currentStep);
        this.renderButtons(this.currentStep);
        $('html, body').animate({ scrollTop: $(this.clusterProgressSelector).offset().top }, 500);
    }
    renderContentPage(stepIndex) {
        const button = $(`[data-step="${stepIndex}"]`);
        const stepId = button.data('step-id');
        const contentNode = $(`[data-node-id="${stepId}"]`);
        const nodeType = contentNode.data('node-type');
        $(this.clusterPageSelector).addClass('Cluster__Page--hidden');
        contentNode.removeClass('Cluster__Page--hidden');
        switch (nodeType) {
            case 'ContentPage':
                gridManager.resize(true);
                break;
            case 'Zorgpad':
                gridManager.resize(true);
                timelineManager.init();
                break;
        }
    }
    renderStepButtons() {
        if (this.currentStep < 1) {
            $(this.clusterStepPrevSelector).addClass('Btn-Hidden');
        }
        else {
            $(this.clusterStepPrevSelector).removeClass('Btn-Hidden');
        }
        if (this.currentStep >= this.lastStepIndex) {
            $(this.clusterStepNextSelector).addClass('Btn-Hidden');
        }
        else {
            $(this.clusterStepNextSelector).removeClass('Btn-Hidden');
        }
    }
    renderButtons(stepIndex) {
        this.renderStepButtons();
        const $steps = $(this.clusterStepSelector);
        if ($steps.length) {
            const button = $(`[data-step="${stepIndex}"]`);
            const stepId = button.data('step-id');
            $(this.clusterPageSelector).addClass('Cluster__Page--hidden');
            $(`[data-node-id="${stepId}"]`).removeClass('Cluster__Page--hidden');
            const allButtonsBefore = button.prevAll();
            allButtonsBefore
                .removeClass(this.buttonActiveClass)
                .removeClass(this.buttonInactiveClass)
                .addClass(this.buttonVisitedClass);
            const allButtonsAfter = button.nextAll();
            allButtonsAfter
                .removeClass(this.buttonActiveClass);
            button
                .removeClass(this.buttonInactiveClass)
                .addClass(this.buttonActiveClass)
                .addClass(this.buttonVisitedClass);
            allButtonsBefore.off().on('click', this.navigateToCurrentPage.bind(this));
            button.off().on('click', this.navigateToCurrentPage.bind(this));
        }
    }
    navigateToCurrentPage(event) {
        const button = $(event.currentTarget);
        const currentStep = button.data('step');
        this.currentStep = currentStep;
        this.handleStep();
    }
}
const clusterManager = new ClusterManager();
export { ClusterManager, clusterManager };
